"use client";

/**
 * ChatbotList Component
 *
 * Displays a list of chatbots in the sidebar.
 * Simplified list without folder hierarchy.
 */
import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { Chatbot } from "@/types/chatbot";
import { ChatbotItem } from "./ChatbotItem";
type ChatbotListProps = {
  /** List of chatbots to display */
  chatbots: Chatbot[];
  /** Currently selected chatbot ID */
  selectedChatbotId: string | null;
  /** Called when a chatbot is selected */
  onSelectChatbot: (id: string) => void;
  /** Called when starting a new thread with a chatbot */
  onStartChatbotThread?: (chatbotId: string, chatbotName: string) => void;
  /** Called when edit settings action is triggered */
  onEditChatbot?: (id: string) => void;
  /** Called when duplicate action is triggered */
  onDuplicateChatbot?: (id: string) => void;
  /** Called when delete action is triggered */
  onDeleteChatbot?: (id: string) => void;
  /** Called when rename is triggered */
  onRenameChatbot?: (id: string, newName: string) => void;
  /** Empty state message */
  emptyMessage?: string;
  /** Additional class names */
  className?: string;
};
export function ChatbotList(t0) {
  const $ = _c(23);
  const {
    chatbots,
    selectedChatbotId,
    onSelectChatbot,
    onStartChatbotThread,
    onEditChatbot,
    onDuplicateChatbot,
    onDeleteChatbot,
    onRenameChatbot,
    emptyMessage: t1,
    className: t2
  } = t0;
  const emptyMessage = t1 === undefined ? "No chatbots yet. Create one to get started." : t1;
  const className = t2 === undefined ? "" : t2;
  if (chatbots.length === 0) {
    const t3 = `px-2 py-1 text-xs text-slate-500 ${className}`;
    let t4;
    if ($[0] !== emptyMessage || $[1] !== t3) {
      t4 = <div className={t3}>{emptyMessage}</div>;
      $[0] = emptyMessage;
      $[1] = t3;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  const t3 = `space-y-1 ${className}`;
  let t4;
  if ($[3] !== chatbots || $[4] !== onDeleteChatbot || $[5] !== onDuplicateChatbot || $[6] !== onEditChatbot || $[7] !== onRenameChatbot || $[8] !== onSelectChatbot || $[9] !== onStartChatbotThread || $[10] !== selectedChatbotId) {
    let t5;
    if ($[12] !== onDeleteChatbot || $[13] !== onDuplicateChatbot || $[14] !== onEditChatbot || $[15] !== onRenameChatbot || $[16] !== onSelectChatbot || $[17] !== onStartChatbotThread || $[18] !== selectedChatbotId) {
      t5 = chatbot => <li key={chatbot.id}><ChatbotItem chatbot={chatbot} isSelected={chatbot.id === selectedChatbotId} onClick={() => onSelectChatbot(chatbot.id)} onStartThread={onStartChatbotThread ? () => onStartChatbotThread(chatbot.id, chatbot.name) : undefined} onEdit={onEditChatbot ? () => onEditChatbot(chatbot.id) : undefined} onDuplicate={onDuplicateChatbot ? () => onDuplicateChatbot(chatbot.id) : undefined} onDelete={onDeleteChatbot ? () => onDeleteChatbot(chatbot.id) : undefined} onRename={onRenameChatbot ? newName => onRenameChatbot(chatbot.id, newName) : undefined} /></li>;
      $[12] = onDeleteChatbot;
      $[13] = onDuplicateChatbot;
      $[14] = onEditChatbot;
      $[15] = onRenameChatbot;
      $[16] = onSelectChatbot;
      $[17] = onStartChatbotThread;
      $[18] = selectedChatbotId;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    t4 = chatbots.map(t5);
    $[3] = chatbots;
    $[4] = onDeleteChatbot;
    $[5] = onDuplicateChatbot;
    $[6] = onEditChatbot;
    $[7] = onRenameChatbot;
    $[8] = onSelectChatbot;
    $[9] = onStartChatbotThread;
    $[10] = selectedChatbotId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[20] !== t3 || $[21] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}